// extracted by mini-css-extract-plugin
export default {"body":"main_body__ornHN","wrapper":"main_wrapper__yUPFu","overflowText":"main_overflowText__xzwjo undefined","link":"main_link__Lxwor"};